import { Card, Text } from '@oneaudi/unified-web-components';
import React from 'react';
import {
  CardWrapper,
  CardContentWrapper,
  ImageWrapper,
  VehicleData,
  NameMileage,
  ClampedText,
  UsedVehicleText,
  PriceText,
  Image,
} from './SidewideSearch.styles';
import type { Vehicle } from '../../../types';

interface VehicleCardProps {
  vehicle: Vehicle;
  showPrice: boolean;
  type: string;
  language?: string;
}

const VehicleCard: React.FC<VehicleCardProps> = ({ vehicle, showPrice, type, language }) => {
  const isFrench = language === 'fr';

  const finalPriceData = vehicle?.carPrices?.find((toCheck) => toCheck.type === 'final')?.price;

  const price = finalPriceData?.formattedValue ?? 'Available Soon';

  const priceFrench =
    finalPriceData?.value != null
      ? new Intl.NumberFormat('fr-CA', {
          style: 'currency',
          currency: 'CAD',
        }).format(finalPriceData.value)
      : 'Bientôt disponible';

  const priceToRender = showPrice ? (isFrench ? priceFrench : price) : null;

  const isUsedVehicle = type === 'CPO' || type === 'USED';

  return (
    <CardWrapper key={vehicle.id} tabIndex={0} href={vehicle.weblink} data-testid="vehicle-card">
      <Card margin={[0, 0, 0, 0]}>
        <CardContentWrapper>
          <ImageWrapper>
            <Image src={vehicle.imageUrl} />
          </ImageWrapper>
          <VehicleData>
            <NameMileage>
              <Text>
                <ClampedText>
                  {vehicle.modelYear} {vehicle.modelName}
                </ClampedText>
              </Text>
              {isUsedVehicle && (
                <UsedVehicleText variant={{ order: '2', style: 'normal' }}>
                  {vehicle.odometerText}
                </UsedVehicleText>
              )}
            </NameMileage>
            <PriceText variant={{ order: '1', style: 'bold' }}>{priceToRender}</PriceText>
          </VehicleData>
        </CardContentWrapper>
      </Card>
    </CardWrapper>
  );
};

export default VehicleCard;
